import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomerService } from '../../customer.service';

@Component({
  selector: 'pv-customer-address',
  templateUrl: './customer-address.component.html',
  styleUrls: ['./customer-address.component.scss']
})
export class CustomerAddressComponent implements OnInit {
  @Input() collapsed: boolean;
  @Input() default: boolean;
  @Input() selectable: boolean;
  @Input() editable: boolean;
  @Output() onNewAddress: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSelectAddress: EventEmitter<any> = new EventEmitter<any>();
  @Output() onEditAddress: EventEmitter<any> = new EventEmitter<any>();

  loggedIn: boolean;
  selected: any;
  type: 'EDIT' | 'SELECT'
  addresses: any[];

  constructor(private customerService: CustomerService) { }

  ngOnInit() {
    this.loggedIn = this.customerService.loggedIn
    this.getAddresses()
  }

  getAddresses() {
    this.customerService.getAddresses()
    .subscribe(addresses => {
      this.addresses = addresses
      if (this.selected && this.selected.id) {
        this.select(addresses.find(x => x.id == this.selected.id))
      } else {
        if (this.default && addresses.length) {
          this.select(addresses[0])
        }
        if (!addresses.length && this.selectable && !this.collapsed) {
          this.newAddress()
        }
      }
    })
  }


  delete(address) {
    this.customerService.deleteAddress(address.id)
    .subscribe(addresses => this.addresses = addresses)
  }

  select(address) {
    this.selected = this.selected == address
      ? null
      : address
    this.type = 'SELECT'
    this.onSelectAddress.emit(address)
  }

  edit(address) {
    if (this.selected == address && this.type == 'EDIT') {
      this.selected = null;
      this.onEditAddress.emit(null)
    } else {
      this.selected = address
      this.type = 'EDIT'
      this.onEditAddress.emit(address)
    }
  }

  newAddress() {
    this.selected = null;
    this.onNewAddress.emit()
  }
}
